import { InfoCircleTwoTone } from "@ant-design/icons";
import { Checkbox, Form, Select, Tooltip } from "antd";
import allowedBooleanValues from "common/data/allowedBooleanValues";
import SchemaClassifiersFieldProperty from "components/atoms/SchemaClassifiersFieldProperty";
import Segment from "components/atoms/Segment";
import CypressTestIds from "../../../cypress/CypressTestIds";

const { Option } = Select;

const BooleanFieldProperties = ({ formRef, selectedFieldRow, readOnly, getFormErrors }) => {
    return (
        <>
            <Segment.Group>
                <Segment className="form-background">
                    <Form.Item
                        label="Allowed Values"
                        name={["fields", selectedFieldRow.name, "allowedBooleanValues"]}
                        initialValue="y/n"
                        {...getFormErrors(`fields.${selectedFieldRow.name}.allowedBooleanValues`)}
                    >
                        <Select {...(() => (readOnly ? { open: false } : {}))()}>
                            {Object.keys(allowedBooleanValues).map((key) => (
                                <Option key={key} value={key}>
                                    {allowedBooleanValues[key].name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Segment>
                <Segment className="form-background">
                    <SchemaClassifiersFieldProperty selectedFieldRow={selectedFieldRow} readOnly={readOnly} getFormErrors={getFormErrors}></SchemaClassifiersFieldProperty>
                </Segment>
                <Segment className="form-background">
                    <Form.Item label="Multi Value" name={["fields", selectedFieldRow.name, "isMultivalue"]} valuePropName="checked" initialValue={false}>
                        <Checkbox disabled={readOnly} data-testid={CypressTestIds.SCHEMA_MULTIVALUE_PROPERTY_CHECKBOX}></Checkbox>
                    </Form.Item>
                </Segment>
                <Segment className="form-background">
                    <Form.Item label="PII" name={["fields", selectedFieldRow.name, "isPII"]} valuePropName="checked" initialValue={false}>
                        <Checkbox disabled={readOnly} data-testid={CypressTestIds.SCHEMA_PII_PROPERTY_CHECKBOX}>
                            <Tooltip title="Flag this field as Personally Identifiable Information or Sensitive Data">
                                <InfoCircleTwoTone />
                            </Tooltip>
                        </Checkbox>
                    </Form.Item>
                </Segment>
            </Segment.Group>
        </>
    );
};

export default BooleanFieldProperties;
